/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var Input_1 = require("./Input");
var InputDate = /** @class */ (function (_super) {
    tslib_1.__extends(InputDate, _super);
    function InputDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputDate.prototype.render = function () {
        var _a = this.props, inputClassName = _a.inputClassName, props = tslib_1.__rest(_a, ["inputClassName"]); // eslint-disable-line react/prop-types
        return (React.createElement(Input_1.Input, tslib_1.__assign({ type: "text", inputClassName: classnames("m-input-date", inputClassName) }, props)));
    };
    InputDate.displayName = "Input.Date";
    InputDate.propTypes = Input_1.Input.propTypes;
    InputDate.defaultProps = tslib_1.__assign({}, Input_1.Input.defaultProps, { type: "text", placeholder: "TT.MM.YYYY" });
    return InputDate;
}(React.Component));
exports.InputDate = InputDate;